<template>
  <router-view></router-view>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  methods: {
    ...mapActions({
      UPDATE_NAV_MENU_HIDDEN: "appConfig/UPDATE_NAV_MENU_HIDDEN",
      A_PERSONAL_WORKING_DAYS: "AttendanceStore/A_PERSONAL_WORKING_DAYS"
    }),
  },
  created() {
    this.UPDATE_NAV_MENU_HIDDEN(true);
    this.A_PERSONAL_WORKING_DAYS();
  },
  destroyed() {
    this.UPDATE_NAV_MENU_HIDDEN(false);
  },
};
</script>

<style>
</style>